import { type ReactElement } from 'react';
import cn from 'classnames';
import { IconSelectSkinny, Text } from '@direct-frontend/components';
import { makeModifierClassname } from '../../lib/makeModifierClassname';
import styles from './Checkbox.module.css';

interface CheckboxProps {
    checked?: boolean;
    invalid?: boolean;
    label?: ReactElement;
    onClick?: VoidFunction;
}

const rootModifier = makeModifierClassname(styles, 'root');
const checkboxModifier = makeModifierClassname(styles, 'checkbox');

export const Checkbox = (props: CheckboxProps) => {
    const { checked, invalid, label, onClick } = props;

    return (
        <label className={cn(rootModifier.className, rootModifier('label', Boolean(label)))} onClick={onClick}>
            <span
                className={cn(
                    checkboxModifier.className,
                    checkboxModifier('checked', checked),
                    checkboxModifier('invalid', invalid)
                )}
            >
                {checked && <IconSelectSkinny size="12" />}
            </span>

            {typeof label === 'string' ? <Text size="mc">{label}</Text> : (label ?? null)}
        </label>
    );
};
